import TravelRestrictionContainer from '../../../../components/containers/TravelRestrictionContainer';
import preloadCustomProps from '../../../utils/preloads/preloadStaticContainerProps';
import deepmerge from '../../../utils/deepmerge';

const cmpConfig = {
  name: 'travel-restriction',
  moduleId: 'em-cmp-lib-airmodules',
  containerConfig: {
    settings: {
      instance: TravelRestrictionContainer
    }
  },
  hooks: {
    params: {},
    preloadCustomProps
  }
};

const finalConfig = deepmerge(cmpConfig, {});

export default finalConfig;
